<tran-application-detail-dashboard-box [heading]="heading()">
    @if (isLoading()) {
        <div class="flex flex-col gap-4" aria-hidden="true">
            <span class="si-skeleton placeholder-lg w-[50%]"></span>
            <span class="si-skeleton placeholder-lg w-full"></span>
            <span class="si-skeleton placeholder-lg w-[80%]"></span>
            <span class="si-skeleton placeholder-lg w-[50%]"></span>
            <span class="si-skeleton placeholder-lg w-full"></span>
            <span class="si-skeleton placeholder-lg w-[70%]"></span>
            <span class="si-skeleton placeholder-lg w-[50%]"></span>
            <span class="si-skeleton placeholder-lg w-full"></span>
            <span class="si-skeleton placeholder-lg w-[60%]"></span>
            <span class="si-skeleton placeholder-lg w-[50%]"></span>
        </div>
    } @else {
        <form [formGroup]="activeForm()" class="flex flex-col gap-4">
            <si-form-item
                [label]="
                    'components.application-detail-dashboard.application-influence-and-impact.contribution' | translate
                "
                [formErrorMapper]="{
                    required: 'application-form.required' | translate,
                    maxlength: 'application-form.max-chars' | translate: { max: 2000 }
                }"
            >
                @if (readonly()) {
                    <textarea class="form-control" readonly formControlName="contribution"></textarea>
                } @else {
                    <textarea
                        class="form-control"
                        placeholder="{{
                            'components.application-detail-dashboard.application-influence-and-impact.contribution-placeholder'
                                | translate
                        }}"
                        formControlName="contribution"
                    ></textarea>
                }
            </si-form-item>
            <si-form-item
                [label]="
                    'components.application-detail-dashboard.application-influence-and-impact.involvement' | translate
                "
                [formErrorMapper]="{
                    required: 'application-form.required' | translate,
                    maxlength: 'application-form.max-chars' | translate: { max: 2000 }
                }"
            >
                @if (readonly()) {
                    <textarea class="form-control" readonly formControlName="involvement"></textarea>
                } @else {
                    <textarea
                        class="form-control"
                        placeholder="{{
                            'components.application-detail-dashboard.application-influence-and-impact.involvement-placeholder'
                                | translate
                        }}"
                        formControlName="involvement"
                    ></textarea>
                }
            </si-form-item>
            <si-form-item
                [label]="
                    'components.application-detail-dashboard.application-influence-and-impact.transfer-and-scalability'
                        | translate
                "
                [formErrorMapper]="{
                    required: 'application-form.required' | translate,
                    maxlength: 'application-form.max-chars' | translate: { max: 2000 }
                }"
            >
                @if (readonly()) {
                    <textarea class="form-control" readonly formControlName="transferAndScalability"></textarea>
                } @else {
                    <textarea
                        class="form-control"
                        placeholder="{{
                            'components.application-detail-dashboard.application-influence-and-impact.transfer-and-scalability-placeholder'
                                | translate
                        }}"
                        formControlName="transferAndScalability"
                    ></textarea>
                }
            </si-form-item>

            <div class="flex flex-col gap-3">
                <div class="form-label">
                    {{ 'components.application-detail-dashboard.application-influence-and-impact.kpis' | translate }}
                </div>
                <tran-kpi-form-array
                    [control]="kpiFormArray()"
                    [rowsKpis]="selectedKpis()"
                    [optionsKpis]="predefinedKpis()"
                    [readonly]="readonly()"
                    [submitted]="false"
                    [title]="'components.kpi-selector.kpi' | translate"
                />
            </div>
        </form>
    }
</tran-application-detail-dashboard-box>
